/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */


import * as httpUtils from '@bingads-webui/http-util';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import * as recommendationRepository from '@bingads-webui-campaign/recommendation-repository';
import { Campaign } from '@bingads-webui-campaign/campaign-ui-schemas';

import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import ChangeStatusView from '@bingads-webui-static-legacy/bulk-edit/view/campaign/changeStatus';
import ChangeStatusModel from '@bingads-webui-static-legacy/bulk-edit/model/campaign/changeStatus';
import ChangeUrlOptionsView from '@bingads-webui-static-legacy/bulk-edit/view/shared/changeUrlOptions';
import ChangeUrlOptionsModel from '@bingads-webui-static-legacy/bulk-edit/model/shared/changeUrlOptions';
import ChangeRsaAutoAssetsView from '@bingads-webui-static-legacy/bulk-edit/view/shared/changeRsaAutoAssets';
import ChangeRsaAutoAssetsModel from '@bingads-webui-static-legacy/bulk-edit/model/shared/changeRsaAutoAssets';
import InlineBudgetEditor from '@bingads-webui-campaign-legacy/budget/view/inline-budget-editor';
import InlineSharedBudgetEditor from '@bingads-webui-campaign-legacy/shared-budget/view/campaigns-grid-inline-shared-budget-editor';
import { Columns, SelectedColumns } from '@bingads-webui-component-legacy/bingads-grid/service/column-chooser-preferences';
import { LegacyColumns, LegacySelectedColumns } from '@bingads-webui-component-legacy/bingads-grid/service/legacy-column-chooser-preferences';
import config from '@bingads-webui-component-legacy/config/index';
import campaignStatus from '@bingads-webui-static-legacy/schema/campaign/status';
import logger from '@bingads-webui-static-legacy/instrumentation/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import jsDataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';
import pageContext from '@bingads-webui-static-legacy/page-context';
import preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import state from '@bingads-webui-component-legacy/state/index';
import { handleSortChange } from '@bingads-webui-campaign-legacy/bingadsgrid/service/state-manager-helper';
import * as criterionLoader from '@bingads-webui-campaign-legacy/base-targets/util/criterionLoader';
import LocationMap from '@bingads-webui-campaign-legacy/location-targets/view/locationMap';
import * as locationTargetConverter from '@bingads-webui-campaign-legacy/location-targets/util/locationTargetConverter';
import CampaignCacheManager from '@bingads-webui-campaign-legacy/cache-manager/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import sessionStorage from '@bingads-webui-component-legacy/storage/sessionStorage';
import jsDataSessionStore from '@bingads-webui-component-legacy/js-data-storage/session-storage';
import { getFilters } from '@bingads-webui-component-legacy/bingads-grid/service/filter-preferences';
import { setSegType, getSegType } from '@bingads-webui-component-legacy/bingads-grid/service/segmentation-preferences';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager'; // eslint-disable-line dot-notation
import decimal from '@bingads-webui-component-legacy/humanize/decimal';


export function getDeps(contexts) {
  const {
    serverContext: {
      CurrentAccount: {
        AdvertiserCustomerID,
        Id,
      },
      Token,
      ServicesEndpoints: { CampaignAPI },
    },
  } = contexts;

  return {
    deps: {
      isNewUI: true,
      CampaignSchema: Campaign,
      ChangeStatusView,
      ChangeStatusModel,
      ChangeUrlOptionsView,
      ChangeUrlOptionsModel,
      ChangeRsaAutoAssetsView,
      ChangeRsaAutoAssetsModel,
      Columns,
      InlineBudgetEditor,
      InlineSharedBudgetEditor,
      LegacyColumns,
      LegacySelectedColumns,
      logger,
      SelectedColumns,
      campaignStatus,
      config,
      criterionLoader,
      edmCampaign,
      handleSortChange,
      i18nErrors,
      jsDataCampaign,
      pageContext,
      preferencesService,
      state,
      s$i18n: window.globalLegacyI18n.get('$/schema-i18n!campaign'),
      i18n: window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/targeting-settings'),
      i18nGlobal: window.globalLegacyI18n.get('module/extension/requirejs/i18n!global'),
      legacyGlobalI18n: window.globalLegacyI18n.get('component/i18n/loader!legacy/global'),
      LocationMap,
      locationTargetConverter,
      odataOptions: {
        host: CampaignAPI,
        oDataToken: Token,
        params: {
          customer_id: AdvertiserCustomerID,
          account_id: Id,
        },
      },
      httpUtils,
      AlertHelper,
      recommendationRepository,
      CampaignCacheManager,
      constants,
      sessionStorage,
      jsDataSessionStore,
      preferenceStoreFactory: {
        getFilters,
      },
      segmentPreference: {
        getSegType,
        setSegType,
      },
      dataContextManager,
      decimal,
    },
  };
}
